<template>
  <div>
    <PersonalList :path="path" :filterPath="filterPath" tituloTabla="Contratos de Cuerpo Técnico"
      action-buttons-name="CuerpoTecnicoListActionButtons" cuerpoTecnico>
    </PersonalList>
    <v-btn v-if="canCreate" app dark fixed fab bottom right class="add-button" @click="newCuerpoTecnico">
      <v-icon>add</v-icon>
    </v-btn>
  </div>
</template>

<script>
import PersonalList from '../components/PersonalList'

export default {
  components: {
    PersonalList
  },

  data () {
    return {
      path: 'cuerpo-tecnico',
      filterPath: 'filters/cuerpo-tecnico'
    }
  },
  computed: {
    canCreate () {
      return this.$store.state.permissions.canAddCuerpoTecnico
    }
  },
  methods: {
    newCuerpoTecnico () {
      this.$router.push({ name: 'nuevoCuerpoTecnico' })
    }
  }
}
</script>
